// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elysium-page {
    padding: 20px;
    background-color: #1a1a1a;
    color: #ffffff;
    font-family: Kim;
}

.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #242b37;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.wallet-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.balance-info {
    display: flex;
    gap: 20px;
}

.balance-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.balance-label {
    font-size: 14px;
    color: #ffcc00;
    margin-bottom: 5px;
}

.balance-value {
    font-size: 24px;
    font-weight: bold;
}

.wallet-button-container {
    display: flex;
    gap: 10px;
}

.withdraw-btn {
    background-color: #ffcc00;
    border: 2px solid #ffaa00;
    color: #fff;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    font-family: Kim;
    font-size: 16px;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.withdraw-btn:hover {
    background-color: #ffaa00;
}

.withdraw-btn:disabled {
    background-color: #cccccc;
    border-color: #bbbbbb;
    cursor: not-allowed;
}

.lobbies-header {
    font-family: 'Kim', sans-serif;
    text-align: center;
    font-size: 28px;
    margin-bottom: 20px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.create-lobby-container {
    text-align: center;
    margin-bottom: 30px;
}

.create-lobby-btn {
    background-color: #ffcc00;
    border: 2px solid #ffaa00;
    color: #fff;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    font-family: Kim;
    font-size: 18px;
    padding: 12px 24px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.create-lobby-info {
    margin-top: 10px;
    font-size: 14px;
    color: #ff4444;
}

.create-lobby-btn:hover {
    background-color: #ffaa00;
    transform: translateY(-2px);
}

.create-lobby-btn:disabled {
    background-color: #cccccc;
    border-color: #bbbbbb;
    cursor: not-allowed;
}

.lobbies-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.lobby-item, .lobby-skeleton {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #242b37;
    border: 1px solid #0096a1;
    border-radius: 10px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.lobby-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 150, 161, 0.3);
}

.lobby-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-bottom: 15px;
    border: 3px solid #ffcc00;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.avatar-spinner {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
}

.loading-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}


.lobby-info {
    text-align: center;
}

.lobby-info h3 {
    margin: 0 0 10px 0;
    color: #ffcc00;
}

.lobby-info p {
    margin: 5px 0;
    font-size: 14px;
}

.lobby-league {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    font-size: 24px;
}

.league-icon {
    width: 38px;
    height: 30px;
    margin-right: 5px;
}

.no-lobbies-message {
    text-align: center;
    padding: 20px;
    color: #999999;
    grid-column: 1 / -1;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.modal {
    background-color: #242b37;
    border: 2px solid #0096a1;
    padding: 30px;
    border-radius: 10px;
    width: 400px;
    color: #ffffff;
    font-family: 'Kim', sans-serif;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal h3 {
    margin-top: 0;
    /* color: #ffcc00; */
    text-align: center;
}

.stake-modal-content {
    margin-top: 20px;
}

.stake-modal-content p {
    margin: 5px 0;
    font-size: 14px;
}

.stake-modal-content label {
    display: block;
    margin-bottom: 10px;
}

.stake-modal-content input {
    width: 100%;
    padding: 10px;
    border: 1px solid #0096a1;
    border-radius: 5px;
    background-color: #1a1a1a;
    color: #ffffff;
}

.modal-footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.cancel-btn, .confirm-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s ease;
}

.cancel-btn {
    background-color: #ff4444;
    color: #ffffff;
    font-family: Kim;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.cancel-btn:hover {
    background-color: #ff0000;
}

.confirm-btn {
    background-color: #ffcc00;
    color: #ffffff;
    font-family: Kim;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.confirm-btn:hover {
    background-color: #ffaa00;
}

.confirm-btn.disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
}

.stake-limits {
    margin-top: 15px;
    font-size: 14px;
}

.stake-limits p {
    margin: 5px 0;
    font-size: 14px;
}

.stake-limits small {
    display: block;
    color: #999999;
    /* font-style: italic; */
    margin-top: 5px;
}

.stake-limits p.invalid {
    color: #ff4444;
}

.lobby-spinner {
    border: 4px solid #242b37;
    border-top: 4px solid #ffcc00;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
    margin: 0 auto;
}

.lobby-stake {
    background-color: rgba(255, 204, 0, 0.1);
    border: 2px solid #ffcc00;
    border-radius: 8px;
    padding: 10px 20px;
    text-align: center;
    width: 100%;
}

.stake-label {
    display: block;
    font-size: 14px;
    color: #ffcc00;
    text-transform: uppercase;
    margin-bottom: 5px;
}

.stake-amount {
    display: block;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media (max-width: 1200px) {
    .lobbies-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .lobbies-container {
        grid-template-columns: 1fr;
    }

    .top-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .wallet-info {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .balance-info {
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }

    .wallet-button-container {
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }
}

.highlight-amount {
    color: #ffcc00;
    font-weight: bold;
}

.lobby-item.insufficient-balance {
    opacity: 0.6;
    cursor: not-allowed;
    position: relative;
}

.insufficient-balance-text {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: rgba(255, 0, 0, 0.7);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/style/ElysiumPage.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,iEAAiE;IACjE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,iEAAiE;IACjE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,iEAAiE;AACrE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,iEAAiE;AACrE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".elysium-page {\n    padding: 20px;\n    background-color: #1a1a1a;\n    color: #ffffff;\n    font-family: Kim;\n}\n\n.top-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #242b37;\n    padding: 20px;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.wallet-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.balance-info {\n    display: flex;\n    gap: 20px;\n}\n\n.balance-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.balance-label {\n    font-size: 14px;\n    color: #ffcc00;\n    margin-bottom: 5px;\n}\n\n.balance-value {\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.wallet-button-container {\n    display: flex;\n    gap: 10px;\n}\n\n.withdraw-btn {\n    background-color: #ffcc00;\n    border: 2px solid #ffaa00;\n    color: #fff;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n    font-family: Kim;\n    font-size: 16px;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.withdraw-btn:hover {\n    background-color: #ffaa00;\n}\n\n.withdraw-btn:disabled {\n    background-color: #cccccc;\n    border-color: #bbbbbb;\n    cursor: not-allowed;\n}\n\n.lobbies-header {\n    font-family: 'Kim', sans-serif;\n    text-align: center;\n    font-size: 28px;\n    margin-bottom: 20px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.create-lobby-container {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.create-lobby-btn {\n    background-color: #ffcc00;\n    border: 2px solid #ffaa00;\n    color: #fff;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n    font-family: Kim;\n    font-size: 18px;\n    padding: 12px 24px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.create-lobby-info {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #ff4444;\n}\n\n.create-lobby-btn:hover {\n    background-color: #ffaa00;\n    transform: translateY(-2px);\n}\n\n.create-lobby-btn:disabled {\n    background-color: #cccccc;\n    border-color: #bbbbbb;\n    cursor: not-allowed;\n}\n\n.lobbies-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.lobby-item, .lobby-skeleton {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    background-color: #242b37;\n    border: 1px solid #0096a1;\n    border-radius: 10px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.lobby-item:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 5px 15px rgba(0, 150, 161, 0.3);\n}\n\n.lobby-avatar {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    margin-bottom: 15px;\n    border: 3px solid #ffcc00;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.avatar-spinner {\n    width: 80px;\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.loading-spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n}\n\n\n.lobby-info {\n    text-align: center;\n}\n\n.lobby-info h3 {\n    margin: 0 0 10px 0;\n    color: #ffcc00;\n}\n\n.lobby-info p {\n    margin: 5px 0;\n    font-size: 14px;\n}\n\n.lobby-league {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 5px 0;\n    font-size: 24px;\n}\n\n.league-icon {\n    width: 38px;\n    height: 30px;\n    margin-right: 5px;\n}\n\n.no-lobbies-message {\n    text-align: center;\n    padding: 20px;\n    color: #999999;\n    grid-column: 1 / -1;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10;\n}\n\n.modal {\n    background-color: #242b37;\n    border: 2px solid #0096a1;\n    padding: 30px;\n    border-radius: 10px;\n    width: 400px;\n    color: #ffffff;\n    font-family: 'Kim', sans-serif;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.modal h3 {\n    margin-top: 0;\n    /* color: #ffcc00; */\n    text-align: center;\n}\n\n.stake-modal-content {\n    margin-top: 20px;\n}\n\n.stake-modal-content p {\n    margin: 5px 0;\n    font-size: 14px;\n}\n\n.stake-modal-content label {\n    display: block;\n    margin-bottom: 10px;\n}\n\n.stake-modal-content input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #0096a1;\n    border-radius: 5px;\n    background-color: #1a1a1a;\n    color: #ffffff;\n}\n\n.modal-footer {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.cancel-btn, .confirm-btn {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: all 0.3s ease;\n}\n\n.cancel-btn {\n    background-color: #ff4444;\n    color: #ffffff;\n    font-family: Kim;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.cancel-btn:hover {\n    background-color: #ff0000;\n}\n\n.confirm-btn {\n    background-color: #ffcc00;\n    color: #ffffff;\n    font-family: Kim;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.confirm-btn:hover {\n    background-color: #ffaa00;\n}\n\n.confirm-btn.disabled {\n    background-color: #cccccc;\n    color: #666666;\n    cursor: not-allowed;\n}\n\n.stake-limits {\n    margin-top: 15px;\n    font-size: 14px;\n}\n\n.stake-limits p {\n    margin: 5px 0;\n    font-size: 14px;\n}\n\n.stake-limits small {\n    display: block;\n    color: #999999;\n    /* font-style: italic; */\n    margin-top: 5px;\n}\n\n.stake-limits p.invalid {\n    color: #ff4444;\n}\n\n.lobby-spinner {\n    border: 4px solid #242b37;\n    border-top: 4px solid #ffcc00;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 1s linear infinite;\n    margin: 0 auto;\n}\n\n.lobby-stake {\n    background-color: rgba(255, 204, 0, 0.1);\n    border: 2px solid #ffcc00;\n    border-radius: 8px;\n    padding: 10px 20px;\n    text-align: center;\n    width: 100%;\n}\n\n.stake-label {\n    display: block;\n    font-size: 14px;\n    color: #ffcc00;\n    text-transform: uppercase;\n    margin-bottom: 5px;\n}\n\n.stake-amount {\n    display: block;\n    font-size: 24px;\n    font-weight: bold;\n    color: #ffffff;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n@media (max-width: 1200px) {\n    .lobbies-container {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .lobbies-container {\n        grid-template-columns: 1fr;\n    }\n\n    .top-bar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .wallet-info {\n        flex-direction: column;\n        align-items: center;\n        gap: 20px;\n    }\n\n    .balance-info {\n        flex-direction: row;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .wallet-button-container {\n        flex-direction: row;\n        justify-content: center;\n        width: 100%;\n    }\n}\n\n.highlight-amount {\n    color: #ffcc00;\n    font-weight: bold;\n}\n\n.lobby-item.insufficient-balance {\n    opacity: 0.6;\n    cursor: not-allowed;\n    position: relative;\n}\n\n.insufficient-balance-text {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    background-color: rgba(255, 0, 0, 0.7);\n    color: white;\n    padding: 5px 10px;\n    border-radius: 5px;\n    font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
